export const venusAPIUrl = 'https://api.venus.io/markets/core-pool?limit=50'; 
export const whalesJSONLocation = 'data/whalemon.json';
export const liquidationsTxJSONLocation = 'data/liqmon.json';
export const vipsJSONLocation = 'data/govmon.json';
export const tvlChangesJSONLocation = 'data/venus_stat.json';
export const APYJSONLocation = 'data/venus_apy.json';
export const primeJSONLocation = 'data/prime.json';
